export default __webpack_public_path__ + "assets/8f82a2963685c7af340f008f9a5c685f.svg";